import { z } from 'zod';

/**
 * Client-safe zod schemas + inferred types for the `retrieve_faqs` tool (FUN-4562).
 * NO `server-only` import so client components can `safeParse` the dynamic
 * `tool.input`/`tool.output` blobs from `UIMessage` parts.
 */

export const RetrieveFaqsFaqSchema = z.object({
    /** The activity this FAQ belongs to — a FAQ can only ever surface its own activity. */
    activityId: z.number().int().positive(),
    question: z.string(),
    /** The exact FAQ answer to ground and cite from — never paraphrase beyond it. */
    answer: z.string(),
});
export type RetrieveFaqsFaq = z.infer<typeof RetrieveFaqsFaqSchema>;

export const RetrieveFaqsOutputSchema = z.object({
    count: z.number().int().nonnegative(),
    faqs: z.array(RetrieveFaqsFaqSchema),
    /**
     * Whether the matched activities should ALSO surface in the results grid
     * (FUN-4562). The model sets this when the FAQ criterion is part of what the
     * user wants to SEE (e.g. "find accessible activities") — not when it's just
     * grounding a factual answer. Echoed from the tool input so the grid bridge
     * can act on the model's intent.
     */
    surfaceInGrid: z.boolean(),
});
export type RetrieveFaqsOutput = z.infer<typeof RetrieveFaqsOutputSchema>;
